<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useEvents } from '@/composables/useEvents'
import EventLogoUpload from '@/components/organizer/events/EventLogoUpload.vue'

const route = useRoute()
const { event, fetchEvent } = useEvents()

const eventSlug = route.params['eventSlug'] as string
const currentLogoUrl = ref<string | null>(null)

onMounted(async () => {
  if (!event.value || event.value.slug !== eventSlug) {
    await fetchEvent(eventSlug)
  }
  currentLogoUrl.value = event.value?.logo_url ?? null
})
</script>

<template>
  <div class="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 sm:p-8">
    <EventLogoUpload
      :event-slug="eventSlug"
      :current-logo-url="currentLogoUrl"
      @logo-updated="(url) => { currentLogoUrl = url }"
    />
  </div>
</template>
